var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.764 3.24c-.316-.32-.829-.32-1.145-.002l-9.71 9.768-3.504-3.838c-.303-.331-.815-.353-1.144-.047-.329.305-.35.821-.047 1.153l4.074 4.463c.15.163.358.258.578.263h.018c.214 0 .42-.086.571-.238L21.762 4.394c.317-.318.317-.835.002-1.154z",
    transform: "translate(-686.000000, -322.000000) translate(686.000000, 322.000000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.17 10.17c-.457 0-.828.372-.828.83 0 5.151-4.19 9.342-9.342 9.342-5.15 0-9.342-4.19-9.342-9.342 0-5.15 4.191-9.342 9.342-9.342.458 0 .83-.37.83-.829C11.83.371 11.457 0 11 0 4.935 0 0 4.935 0 11s4.935 11 11 11 11-4.935 11-11c0-.458-.371-.83-.83-.83z",
    transform: "translate(-686.000000, -322.000000) translate(686.000000, 322.000000)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/checkCircle.07cc9ab0.svg";
export { ForwardRef as ReactComponent };